export default __webpack_public_path__ + "media/images/ui.totop-d2d0ac044d16ac47e9c92f0723301763.png";